import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import RentalImg1 from '../../assest/Rental-1.png';
import RentalImg2 from '../../assest/Rental-2.jpeg';
import RentalImg3 from '../../assest/Rental-3.jpeg';

// Rental equipment data with translations
const rentalEquipmentList = (language) => [
  {
    name: {
      gb: "Forklift",
      sa: "رافعة شوكية",
      fr: "Chariot élévateur",
      de: "Gabelstapler"
    },
    image: RentalImg1,
    specs: {
      gb: "Heavy lifting made easy.",
      sa: "رفع الأحمال الثقيلة بشكل سهل.",
      fr: "Levage lourd facilité.",
      de: "Schweres Heben leicht gemacht."
    },
    description: {
      gb: "Perfect for warehouse operations and material handling.",
      sa: "مثالي لعمليات المستودعات ومعالجة المواد.",
      fr: "Parfait pour les opérations d'entrepôt et la manutention de matériaux.",
      de: "Perfekt für Lageroperationen und Materialhandhabung."
    },
  },
  {
    name: {
      gb: "Aerial Work Platform",
      sa: "منصة العمل الجوية",
      fr: "Plateforme de travail aérien",
      de: "Arbeitsbühne"
    },
    image: RentalImg2,
    specs: {
      gb: "Safe access to heights.",
      sa: "وصول آمن إلى المرتفعات.",
      fr: "Accès sécurisé aux hauteurs.",
      de: "Sicherer Zugang zu Höhen."
    },
    description: {
      gb: "Ideal for maintenance and construction work at heights.",
      sa: "مثالي لأعمال الصيانة والبناء على ارتفاعات.",
      fr: "Idéal pour les travaux de maintenance et de construction en hauteur.",
      de: "Ideal für Wartungs- und Bauarbeiten in der Höhe."
    },
  },
  {
    name: {
      gb: "Concrete Mixer",
      sa: "خلاطة الخرسانة",
      fr: "Bétonnière",
      de: "Betonmischer"
    },
    image: RentalImg3,
    specs: {
      gb: "Efficient concrete mixing.",
      sa: "خلط الخرسانة بكفاءة.",
      fr: "Mélange de béton efficace.",
      de: "Effiziente Betonmischung."
    },
    description: {
      gb: "Best for construction projects of all sizes.",
      sa: "الأفضل لمشاريع البناء بجميع أحجامها.",
      fr: "Idéal pour les projets de construction de toutes tailles.",
      de: "Am besten für Bauprojekte aller Größen."
    },
  },
];

// Translations for Rental Terms page
const translations = {
  gb: {
    heading: "Rental Equipment",
    introText: "Reliable rental equipment for your project needs.",
    categoriesTitle: "Available Rental Equipment",
    featuredTitle: "Featured Rentals",
    featuredDescription: "Our best rental options for all projects.",
  },
  sa: {
    heading: "معدات الإيجار",
    introText: "معدات الإيجار الموثوقة لتلبية احتياجات مشروعك.",
    categoriesTitle: "معدات الإيجار المتاحة",
    featuredTitle: "الإيجارات المميزة",
    featuredDescription: "أفضل خيارات الإيجار لجميع المشاريع.",
  },
  fr: {
    heading: "Équipement de location",
    introText: "Équipement de location fiable pour vos besoins de projet.",
    categoriesTitle: "Équipement de location disponible",
    featuredTitle: "Locations en vedette",
    featuredDescription: "Nos meilleures options de location pour tous les projets.",
  },
  de: {
    heading: "Vermietungsausrüstung",
    introText: "Zuverlässige Vermietungsausrüstung für Ihre Projektanforderungen.",
    categoriesTitle: "Verfügbare Vermietungsausrüstung",
    featuredTitle: "Empfohlene Vermietungen",
    featuredDescription: "Unsere besten Mietoptionen für alle Projekte.",
  },
};

const RentalTerms = () => {
  const { language } = useSelector(state => state.language);
  const t = translations[language] || translations.gb;

  // Process equipment list with current language
  const processedEquipmentList = rentalEquipmentList().map(item => ({
    name: item.name[language] || item.name.gb,
    image: item.image,
    specs: item.specs[language] || item.specs.gb,
    description: item.description[language] || item.description.gb
  }));

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={processedEquipmentList}
      language={language}
    />
  );
};

export default RentalTerms;